// 公共
import meFooter from './common/meFooter.vue'
import meHeader from './common/meHeader.vue'
import carousel from './common/carousel.vue'
import meMap from './common/map.vue'
import tabsCenter from './common/tabsCenter.vue'
import mePagination from './common/mePagination.vue'
import rotate3d from './common/rotate3d.vue'
import articel from './common/articel.vue'
// 走进翱锐
import introductionG from './go/introductionG.vue'
import messageFounderG from './go/messageFounderG.vue'
import devHistoryG from './go/devHistoryG.vue'
import honorG from './go/honorG.vue'
import goodnessG from './go/goodnessG.vue'
import CooperationG from './go/CooperationG.vue'
import contactG from './go/contactG.vue'
// // 产品中心
import cancerDetectionP from './product/cancerDetectionP.vue'
import cancerP from './product/cancerP.vue'
// import infoP from './product/infoP.vue'
import sourceP from './product/sourceP.vue'
import technologyP from './product/technologyP.vue'
// // 新闻中心
import newA from './news/newA.vue'
import newB from './news/newB.vue'

export default {
    install(Vue) {
        //公共组件
        Vue.component('meFooter', meFooter)
        Vue.component('meHeader', meHeader)
        Vue.component('carousel', carousel)
        Vue.component('meMap', meMap)
        Vue.component('tabsCenter', tabsCenter)
        Vue.component('mePagination', mePagination)
        Vue.component('rotate3d', rotate3d)
        Vue.component('articel',articel)
        // Vue.component('Pagination',Pagination)
        // 页面组件
        // 走进翱锐
        Vue.component('introductionG', introductionG)
        Vue.component('messageFounderG', messageFounderG)
        Vue.component('devHistoryG', devHistoryG)
        Vue.component('honorG', honorG)
        Vue.component('goodnessG', goodnessG)
        Vue.component('CooperationG', CooperationG)
        Vue.component('contactG', contactG)
        // // 产品中心
        Vue.component('cancerDetectionP', cancerDetectionP)
        Vue.component('cancerP', cancerP)
        // Vue.component('infoP', infoP)
        Vue.component('sourceP', sourceP)
        Vue.component('technologyP', technologyP)
        // // 新闻中心
        Vue.component('newA', newA)
        Vue.component('newB', newB)

    }
}


// WEBPACK FOOTER //
// ./src/components/index.js